import React, { ReactElement } from 'react';

import { AccountDetails } from '@pb/shared/ui/organisms/account-details';
import { NotificationList } from '@pb/shared/ui/atoms/notification-list';
import { MyPurplebricksLogo } from '@pb/shared/ui/atoms/my-purplebricks-logo';
import { ButtonIcon } from '@pb/shared/ui/atoms/button-icon';
import { Badge } from '@pb/shared/ui/atoms/badge';
import { useIsDevice } from '@pb/hooks';
import { TAccountNavBarProperties } from './account-nav-bar.types';
import {
    StyledAccountNavBar,
    StyledList,
    StyledListItems,
    StyledIconWrapper,
    StyledContainer,
    StyledLogoContainer,
    StyledLogoLink,
    StyledButtonIcon,
} from './account-nav-bar.styled';

export function AccountNavBar({
    homepageUrl,
    isMenuOpen,
    onMenuClick,
    onAccountMenuClick,
    isAccountMenuOpen,
    setIsNotificationMenuOpen,
    isNotificationMenuOpen,
    accountNavigationMenuItems,
    notificationListItems = [],
    isCustomer = true,
    reference,
}: TAccountNavBarProperties): ReactElement {
    const isMobile = useIsDevice('mobile');
    const isTabletPortrait = useIsDevice('tabletPortrait');
    const isTabletLandscape = useIsDevice('tabletLandscape');
    const isDesktop = useIsDevice('desktop');
    const isLargeScreen = isTabletLandscape || isDesktop;

    function handleIsNotificationMenuOpen() {
        setIsNotificationMenuOpen(!isNotificationMenuOpen);
    }

    return (
        <StyledAccountNavBar>
            <StyledContainer>
                <StyledLogoContainer>
                    {!isLargeScreen && (
                        <StyledButtonIcon
                            ariaLabel="Open or Close menu"
                            icon={isMenuOpen ? 'removeOrClose' : 'menu'}
                            color="black"
                            onClick={onMenuClick}
                            id="toggleNav"
                        />
                    )}
                    <StyledLogoLink
                        to={homepageUrl}
                        ariaLabel="Purplebricks home page"
                    >
                        <MyPurplebricksLogo
                            type={
                                isMobile || isTabletPortrait ? 'small' : 'large'
                            }
                        />
                    </StyledLogoLink>
                </StyledLogoContainer>
                <StyledList>
                    {isCustomer && (
                        <StyledListItems>
                            <ButtonIcon
                                icon="notify"
                                color="black"
                                isOpen={isNotificationMenuOpen}
                                onClick={handleIsNotificationMenuOpen}
                                ariaLabel="Click to open the notification dropdown"
                            />
                            {notificationListItems &&
                                notificationListItems.length > 0 && (
                                    <StyledIconWrapper aria-label="Notification badge">
                                        <Badge
                                            count={notificationListItems.length}
                                        />
                                    </StyledIconWrapper>
                                )}

                            {isNotificationMenuOpen && (
                                <NotificationList
                                    reference={reference}
                                    onClose={handleIsNotificationMenuOpen}
                                    notificationItems={notificationListItems}
                                />
                            )}
                        </StyledListItems>
                    )}
                    <StyledListItems>
                        <ButtonIcon
                            icon="account"
                            isOpen={isAccountMenuOpen}
                            color="black"
                            onClick={onAccountMenuClick}
                            ariaLabel="Click to open the account dropdown"
                        />
                        {isAccountMenuOpen ? (
                            <AccountDetails
                                navigationItems={accountNavigationMenuItems}
                                reference={reference}
                            />
                        ) : null}
                    </StyledListItems>
                </StyledList>
            </StyledContainer>
        </StyledAccountNavBar>
    );
}
